export const createConditionReport = () => {
    return {
        coverHealthCertForm: () => {
            const report = { group: 'HEALTH_CERT', key: 'cover' };
            return report;
        },
        healthCertForm: ({ modelRef }) => {
            const report = { group: 'HEALTH_CERT', key: modelRef.refRequestForm?.attribute?.keyReport};
            // const requestFormKey = modelRef.refRequestForm?.key;
            // if (requestFormKey === 'UK') {
            //     report.key = 'uk'
            // } else if (requestFormKey === 'CN-Frozen') {
            //     report.key = 'china'
            // } else {
            //     report.key = 'uk'
            // }
            return report;
        },
        intransitForm: ({ modelRef }) => {
            const report = { group: 'HEALTH_CERT', key: modelRef.refIntransitForm?.attribute?.keyReport};
            // const intransitFormKey = modelRef.refIntransitForm?.key;
            // if (intransitFormKey === 'UK') {
            //     report.key = 'uk'
            // } else if (intransitFormKey === 'CN-Frozen') {
            //     report.key = 'china'
            // } else {
            //     report.key = 'uk'
            // }
            return report;
        },
        requestChangeForm: ({ modelRef }) => {
            const report = { group: 'HEALTH_CERT' };
            const intransitFormKey = modelRef.refIntransitForm?.key;
            if (intransitFormKey === 'UK') {
                report.key = 'uk'
            } else if (intransitFormKey === 'CN-Frozen') {
                report.key = 'china'
            } else {
                report.key = 'uk'
            }
            return report;
        },
        changeRequestForm: () => {
            const report = { group: 'HEALTH_CERT' };
            report.key = 'change_request'
            return report;
        },
    }
}